import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '../../node_modules/@angular/common';

@Pipe({
  name: 'dateFormat'
})
export class DateFormatPipe extends DatePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    let fechaformateada;

    if(value){
      fechaformateada=value.replace(" ","T");
    }else{
      fechaformateada=value;
    }
    
    return super.transform(fechaformateada, 'dd/MM/yyyy');
  }

}



// WEBPACK FOOTER //
// ./src/app/date-format.pipe.ts